import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Pipe({
  name: 'removeUnknownLocation'
})
export class RemoveUnknownLocationPipe implements PipeTransform {

  transform(fleets: any, type: string): unknown {
    switch (type) {
      case 'host':
        return fleets && fleets.filter(host => host.latitude && host.longitude);
      default:
        return fleets && fleets.filter(train => train.currentPosition && train.currentPosition.latitude && train.currentPosition.longitude);
    }
  }
}
